export default function Button({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  disabled = false,
  fullWidth = false,
  icon = null,
  loading = false
}) {
  const variants = {
    primary: 'bg-emerald-700 hover:bg-emerald-800 text-white',
    secondary: 'bg-white hover:bg-gray-50 text-[#191d23] border border-[#d8dae5]',
    outline: 'bg-transparent hover:bg-emerald-50 text-emerald-700 border border-emerald-700',
    danger: 'bg-red-600 hover:bg-red-700 text-white',
    ghost: 'bg-transparent hover:bg-gray-100 text-[#191d23]'
  };

  const sizes = {
    small: 'h-8 px-3 text-sm',
    medium: 'h-10 px-4 text-base',
    large: 'h-12 px-6 text-lg'
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        flex items-center justify-center gap-2 rounded font-semibold
        transition-all disabled:opacity-50 disabled:cursor-not-allowed
      `}
    >
      {loading ? (
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        <>
          {icon && icon}
          {children}
        </>
      )}
    </button>
  );
}